import { Flex } from '@atlaskit/primitives';

import SiteSelector from './SiteSelector/SiteSelector';
import type { FunctionComponent } from 'react';
import LegalDisclaimer from './LegalDisclaimer/LegalDisclaimer';
import Headline from './Headline';
import PermissionsBullets from './PermissionsBullets';
import SiteBypassBanner from '../shared/agent-consent/SiteBypassBanner/SiteBypassBanner';
import useRovoVisualRefresh from './useRovoVisualRefresh';

const Rovo: FunctionComponent = () => {
  // In the refreshed flow the legal copy moves to the sticky action footer
  // (RovoStickyFooter), so the in-content legal block is omitted to avoid
  // duplicating it. Legacy flow keeps the bulleted block here.
  const rovoVisualRefresh = useRovoVisualRefresh();

  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Flex alignItems="center" direction="column" gap="space.400">
        <Headline />
      </Flex>
      <SiteBypassBanner />
      <SiteSelector />
      <PermissionsBullets />
      {!rovoVisualRefresh && <LegalDisclaimer />}
    </Flex>
  );
};

export default Rovo;
